<template>
  <el-row class="search-filters">
    <div
      class="wrap-category"
      :class="{wrapper:!category}"
    >
      <div
        v-if="!category"
        class="category-select"
      >
        <el-button
          v-for="(itemCategory, index) in categories"
          :key="itemCategory.key || index"
          class="category-buttons"
          :icon="'icon-'+itemCategory.key"
          :class="{
            active : category && category.key === itemCategory.key,
            inactive : category && category.key !== itemCategory.key,
          }"
          @click="selectCategory(itemCategory)"
        >
          {{ itemCategory.key ? $t('category.' + itemCategory.key) : ' ' }}
        </el-button>
      </div>
    </div>
    <div
      v-if="category || subcategory"
      class="filters"
    >
      <span
        v-if="category"
        class="mobile-filter"
      >{{ $t('category.' + category.key) }}<i
        class="icon-close"
        @click="removeCategory()"
      /></span>
      <span
        v-if="subcategory"
        class="mobile-filter"
      >{{ $t('subcategory.' + category.key + '.' + subcategory.key) }}<i
        class="icon-close"
        @click="removeSubcategory()"
      /></span>
      <template v-for="(filter, index) in dynamicAttributes">
        <span
          v-if="filter"
          :key="index"
          class="mobile-filter"
        >
          {{ filter.type && filter.type.type === 'range' ? $t('filter.'+ filter.type.key + '.label') + ': ' : '' }}
          {{ filter && filter.value ? dataGet(`value.translations.${locale}`, filter, filter.value.value) || filter.value.join(' - ') : '' | formatTag }}
          <i
            class="icon-close"
            @click="removeDynamicField(filter.type.id)"
          />
        </span>
      </template>
    </div>
  </el-row>
</template>
<script>
  import { mapState } from 'vuex';
  import mutations from '@/store/filters/filters.mutationlist';
  import { dataGet } from '@fps/vue-toolkit/dist/util';

  export default {
    computed: {
      ...mapState({
        locale: state => state.locale,
        category: state => state.filters.category,
        subcategory: state => state.filters.subcategory,
        dynamicAttributes: state => state.filters.dynamic,
        isMobile: state => state.isMobile,
        categories: state => state.temp.categories.list,
      }),
    },
    methods: {
      selectCategory(category) {
        this.$store.dispatch('setCategory', category);
      },
      removeCategory() {
        this.$store.dispatch('setCategory', null);
      },
      removeSubcategory() {
        this.$store.dispatch('setSubcategory', null);
      },
      removeDynamicField(atTypeId) {
        this.$store.commit(mutations.REMOVE_ATTRIBUTE, atTypeId);
      },
      dataGet(...args) {
        return dataGet(...args);
      },
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/SearchFilters.vue